module.exports = "<div class='device-console'>\n    <pre class='out'></pre>\n<div>\n"